import { addMessages } from '@hana/i18n';

// Khoá chuỗi Ezy › Dịch vụ › iPad / điện thoại. Mã dịch vụ, ServiceID, tên riêng và dữ liệu không dịch.
addMessages('vi', {
  'svc.act.view': 'Xem', 'svc.act.shoot': 'Chụp', 'svc.act.move': 'Chuyển bước',
  'svc.seg.open': 'Đang làm',
  'svc.seg.new': 'Mới',
  'svc.seg.late': 'Trễ',
  'svc.seg.done': 'Xong',
  'svc.noWrite': 'Chưa mở ghi ở bản này',
  'svc.emptyMine': 'Bạn không có việc dịch vụ nào',
  'svc.emptyOpen': 'Không có việc dịch vụ đang mở',
  'svc.emptyMineDesc': 'Việc mới sẽ báo qua Thông báo.',
  'svc.emptyOpenDesc': 'Việc mới được giao tự động khi job thêm CCF, COO, FUM, PTF, SCY, ISR, DDL.',
  'svc.retry': 'Thử lại',
  'svc.tasks': 'Việc dịch vụ',
  'svc.mine': 'Của tôi',
  'svc.team': 'Cả team',
  'svc.filter': 'Lọc',
  'svc.noInSeg': 'Không có việc trong mục này',
  'svc.sheetTitle': 'Chi tiết việc dịch vụ',
  'svc.all': 'Tất cả',
  'svc.title': 'Dịch vụ',
  'svc.viewKind': 'Kiểu xem',
  'svc.list': 'Danh sách',
  'svc.hsSoon': 'Tư vấn HS chưa mở ở bản này',
  'svc.hs': 'Tư vấn HS',
  'svc.moreAct': 'Tác vụ khác',
  'svc.kind': 'Loại dịch vụ',
  'svc.search': 'Tìm việc dịch vụ',
  'svc.searchPh': 'ServiceID / job / booking / khách',
  'svc.scope': 'Phạm vi',
  'svc.late': 'Trễ',
  'svc.urg': 'Gấp',
  'svc.noMatch': 'Không có việc khớp lọc',
  'svc.stepNo': 'bước {n}',
  'svc.done': 'Hoàn tất',
  'svc.missN': 'Thiếu {n} điều kiện',
  'svc.ready': 'Đủ điều kiện chuyển bước',
  'svc.moveTo': 'Chuyển sang “{next}”',
  'svc.backTasks': 'Quay lại danh sách việc',
  'svc.photo': 'Ảnh',
  'svc.docs': 'Chứng từ',
  'svc.cost': 'Chi phí',
  'svc.content': 'Nội dung việc',
  'svc.photoHave': 'Ảnh {k} đã có',
  'svc.photoNone': 'Ảnh {k} chưa có',
  'svc.viewfinder': 'Khung ngắm máy ảnh',
  'svc.frameIn': 'Canh {k} trong khung',
  'svc.photoWord': 'ảnh',
  'svc.camHint': 'Kiểm nét · tự chụp khi rõ · gắn GPS + giờ',
  'svc.shoot': 'Chụp {k}',
  'svc.pickFile': 'Chọn tệp',
  'svc.missNl': 'thiếu {n} điều kiện',
  'svc.okl': 'đủ điều kiện',
  'svc.needDocs': 'Hồ sơ cần',
  'svc.moneyNote': 'Chi phí & doanh thu chỉ hiện với người có quyền tiền.',
  'svc.before': 'trước “{next}”',
  'svc.svcDone': 'Dịch vụ đã hoàn tất',
  'svc.curStep': 'Bước hiện tại: {cur}',
  'svc.dueS': 'hạn {d}',
  'svc.addDocs': 'Bổ sung {n} hồ sơ còn thiếu',
  'svc.shootN': 'Chụp {n} ảnh hiện trường',
  'svc.i.id': 'Mã dịch vụ',
  'svc.i.cust': 'Khách',
  'svc.i.vessel': 'Hãng · tàu',
  'svc.i.route': 'Tuyến',
  'svc.explain': 'Giải thích: {title}',
  'svc.toggle': 'Mở / gập {title}',
  'svc.toggleT': 'Mở / gập',
  'svc.backSvc': 'Quay lại danh sách dịch vụ',
  'svc.auto': 'giao tự động',
  'svc.dueHint': 'Hạn theo giờ làm việc · {kpi}',
  'svc.due': 'Hạn',
  'svc.otherOps': 'Thao tác khác',
  'svc.finished': 'Đã xong',
  'svc.complete': 'Hoàn tất dịch vụ',
  'svc.advance': 'Chuyển bước tiếp',
  'svc.process': 'Quy trình',
  'svc.docsAi': 'Hồ sơ · AI',
  'svc.files': 'Tệp & ảnh',
  'svc.mail': 'Mail mẫu',
  'svc.svcContent': 'Nội dung dịch vụ',
  'svc.shipment': 'Lô hàng',
  'svc.gate': 'Điều kiện còn thiếu',
  'svc.cannot': 'Chưa sang “{next}” được',
  'svc.sopStep': 'SOP bước',
  'svc.profile': 'Hồ sơ dịch vụ',
  'svc.profileOf': 'Hồ sơ {name}',
  'svc.profNote': 'Hồ sơ riêng của dịch vụ và Ask HANA đọc chứng từ chưa mở ở bản này.',
  'svc.sitePhotos': 'Ảnh hiện trường',
  'svc.noPhotos': 'Dịch vụ này không yêu cầu ảnh hiện trường',
  'svc.svcMail': 'Mail mẫu của dịch vụ',
  'svc.noSend': 'Chỉ dựng màn; không gửi thật.',
  'svc.todo': 'Việc cần làm',
  'svc.info': 'Thông tin chính',
});
addMessages('en', {
  'svc.act.view': 'View', 'svc.act.shoot': 'Take photo', 'svc.act.move': 'Advance',
  'svc.seg.open': 'Active',
  'svc.seg.new': 'New',
  'svc.seg.late': 'Late',
  'svc.seg.done': 'Done',
  'svc.noWrite': 'Write is not enabled in this version',
  'svc.emptyMine': 'You have no service tasks',
  'svc.emptyOpen': 'No open service tasks',
  'svc.emptyMineDesc': 'New tasks will arrive in Notifications.',
  'svc.emptyOpenDesc': 'New tasks are assigned automatically when a job adds CCF, COO, FUM, PTF, SCY, ISR, DDL.',
  'svc.retry': 'Retry',
  'svc.tasks': 'Service tasks',
  'svc.mine': 'Mine',
  'svc.team': 'Whole team',
  'svc.filter': 'Filter',
  'svc.noInSeg': 'No tasks in this section',
  'svc.sheetTitle': 'Service task detail',
  'svc.all': 'All',
  'svc.title': 'Services',
  'svc.viewKind': 'View',
  'svc.list': 'List',
  'svc.hsSoon': 'HS advice is not available in this version yet',
  'svc.hs': 'HS advice',
  'svc.moreAct': 'More actions',
  'svc.kind': 'Service type',
  'svc.search': 'Search service tasks',
  'svc.searchPh': 'ServiceID / job / booking / customer',
  'svc.scope': 'Scope',
  'svc.late': 'Late',
  'svc.urg': 'Urgent',
  'svc.noMatch': 'No tasks match the filters',
  'svc.stepNo': 'step {n}',
  'svc.done': 'Done',
  'svc.missN': '{n} conditions missing',
  'svc.ready': 'Ready to advance',
  'svc.moveTo': 'Move to “{next}”',
  'svc.backTasks': 'Back to task list',
  'svc.photo': 'Photos',
  'svc.docs': 'Documents',
  'svc.cost': 'Costs',
  'svc.content': 'Task content',
  'svc.photoHave': 'Photo {k} is on file',
  'svc.photoNone': 'Photo {k} is missing',
  'svc.viewfinder': 'Camera viewfinder',
  'svc.frameIn': 'Frame {k} in the box',
  'svc.photoWord': 'photo',
  'svc.camHint': 'Focus check · auto-capture when sharp · GPS + time stamped',
  'svc.shoot': 'Take {k}',
  'svc.pickFile': 'Choose file',
  'svc.missNl': '{n} conditions missing',
  'svc.okl': 'ready',
  'svc.needDocs': 'Required documents',
  'svc.moneyNote': 'Costs & revenue are visible only to people with money permission.',
  'svc.before': 'before “{next}”',
  'svc.svcDone': 'Service completed',
  'svc.curStep': 'Current step: {cur}',
  'svc.dueS': 'due {d}',
  'svc.addDocs': 'Add {n} missing documents',
  'svc.shootN': 'Take {n} site photos',
  'svc.i.id': 'Service ID',
  'svc.i.cust': 'Customer',
  'svc.i.vessel': 'Carrier · vessel',
  'svc.i.route': 'Route',
  'svc.explain': 'Explain: {title}',
  'svc.toggle': 'Expand / collapse {title}',
  'svc.toggleT': 'Expand / collapse',
  'svc.backSvc': 'Back to service list',
  'svc.auto': 'auto-assigned',
  'svc.dueHint': 'Due by working hours · {kpi}',
  'svc.due': 'Due',
  'svc.otherOps': 'Other operations',
  'svc.finished': 'Finished',
  'svc.complete': 'Complete service',
  'svc.advance': 'Advance to next step',
  'svc.process': 'Process',
  'svc.docsAi': 'Documents · AI',
  'svc.files': 'Files & photos',
  'svc.mail': 'Mail template',
  'svc.svcContent': 'Service content',
  'svc.shipment': 'Shipment',
  'svc.gate': 'Missing conditions',
  'svc.cannot': 'Cannot move to “{next}” yet',
  'svc.sopStep': 'SOP step',
  'svc.profile': 'Service file',
  'svc.profileOf': '{name} file',
  'svc.profNote': 'The service file and Ask HANA document reading are not available in this version yet.',
  'svc.sitePhotos': 'Site photos',
  'svc.noPhotos': 'This service does not require site photos',
  'svc.svcMail': 'Service mail template',
  'svc.noSend': 'Layout only; nothing is sent.',
  'svc.todo': 'To do',
  'svc.info': 'Key information',
});
